// nono-sticky.js: behaviour for the bottom of the shell (00 §04 sticky bar, 00 §05 footer groups).
// FRAMEWORK §10.2 item 7: header + sticky bar may take at most 25 % of the visual viewport, otherwise the bar goes
// back in flow (data-unstick). While the bar floats on screen, --sticky-bar-height is written on :root (consent
// banner offset + scroll-padding, WCAG 2.4.11) and removed otherwise. Footer «Utforsk Nono» / «For deg» become
// +/− disclosures below 48em (FERDIG 00 §05, 239:10351); without JS every list stays open.

const root = document.documentElement;
const bar = document.querySelector('[data-sticky-bar]');

if (bar) {
  const wrap = bar.closest('.shopify-section') || bar;
  const vv = window.visualViewport;
  const footer = document.querySelector('.shell-footer');
  let queued = 0;

  const headerHeight = () => {
    const h = document.querySelector('.shell-header');
    if (!h) return 0;
    const w = h.closest('.shopify-section') || h;
    const fixed = (el) => /sticky|fixed/.test(getComputedStyle(el).position);
    return fixed(w) || fixed(h) ? h.getBoundingClientRect().height : 0;
  };

  const update = () => {
    queued = 0;
    const vh = vv ? vv.height : innerHeight;
    const barH = bar.offsetHeight;
    const unstick = headerHeight() + barH > vh * 0.25;
    const footTop = footer ? footer.getBoundingClientRect().top : Infinity;
    const shown = unstick || scrollY > vh * 0.5 || footTop < vh;
    wrap.toggleAttribute('data-unstick', unstick);
    wrap.toggleAttribute('data-sticky-shown', shown);
    // Only while it floats over content (not when docked in flow above the footer).
    if (shown && !unstick && bar.getBoundingClientRect().bottom > vh - 2) root.style.setProperty('--sticky-bar-height', `${barH}px`);
    else root.style.removeProperty('--sticky-bar-height');
  };

  const queue = () => {
    if (!queued) queued = requestAnimationFrame(update);
  };

  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue);
  vv?.addEventListener('resize', queue);
  if ('ResizeObserver' in window) new ResizeObserver(queue).observe(bar);
  update();

  // Never let the floating bar hide the focused element (scroll-padding covers most browsers; this covers the rest).
  document.addEventListener('focusin', (e) => {
    const t = e.target;
    if (bar.contains(t) || wrap.hasAttribute('data-unstick') || !wrap.hasAttribute('data-sticky-shown')) return;
    const limit = bar.getBoundingClientRect().top;
    if (t.getBoundingClientRect?.().bottom > limit) t.scrollIntoView({ block: 'nearest' });
  });
}

const groups = document.querySelectorAll('[data-footer-group]');
if (groups.length) {
  const mq = matchMedia('(min-width: 48em)');
  const apply = () => {
    for (const g of groups) {
      const btn = g.querySelector('[data-footer-toggle]');
      const label = g.querySelector('[data-footer-label]');
      const list = g.querySelector('[data-footer-list]');
      const desktop = mq.matches;
      btn.hidden = desktop;
      label.hidden = !desktop;
      list.hidden = !desktop && btn.getAttribute('aria-expanded') !== 'true';
    }
  };
  for (const g of groups) {
    g.querySelector('[data-footer-toggle]').addEventListener('click', (e) => {
      const btn = e.currentTarget;
      btn.setAttribute('aria-expanded', String(btn.getAttribute('aria-expanded') !== 'true'));
      apply();
    });
  }
  mq.addEventListener('change', apply);
  apply();
}
